import { em, math } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`

export const GoogleMapContainer = styled.div`
  height: 100%;
`

export const GoogleMapControls = styled.div`
  position: absolute;
  right: ${p => p.theme.indents.baseIndentXs};
  bottom: ${em(40)};
  z-index: 11;

  ${p => p.theme.mq.upMd} {
    right: ${p => p.theme.indents.baseIndentMd};
  }

  ${p => p.theme.mq.upLg} {
    right: ${p => math(`${p.theme.indents.baseBoxIndentLg} / 2`)};
  }
`

export const ButtonBox = styled.div`
  margin-top: ${em(20)};
  margin-bottom: ${em(20)};
`
